import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-dark.svg';

const Footer = () => {
  const buyAndSell = [
    { label: 'Browse Listings', to: '/listings' },
    { label: 'Post an Ad', to: '/post-ad' },
    { label: 'Deals & Offers', to: '/deals' },
    { label: 'Quick Sell', to: '/post-ad' },
    { label: 'My Ads', to: '/my-ads' },
    { label: 'Wishlist', to: '/wishlist' },
  ];

  const categories = [
    { label: 'Electronics', to: '/listings?category=electronics' },
    { label: 'Vehicles', to: '/listings?category=vehicles' },
    { label: 'Property', to: '/listings?category=property' },
    { label: 'Fashion', to: '/listings?category=fashion' },
    { label: 'Furniture', to: '/listings?category=furniture' },
    { label: 'Jobs & Careers', to: '/careers' },
    { label: 'Agriculture', to: '/listings?category=agriculture' },
    { label: 'Services', to: '/listings?category=services' },
  ];

  const company = [
    { label: 'About Us', to: '/about' },
    { label: 'Careers', to: '/careers' },
    { label: 'Blog', to: '/blog' },
    { label: 'Press', to: '/about' },
  ];

  const support = [
    { label: 'Help Center', to: '/help-center' },
    { label: 'Report a Problem', to: '/report-problem' },
    { label: 'Safety Tips', to: '/help-center' },
    { label: 'Contact Us', to: '/help-center' },
  ];

  const socials = [
    { label: 'Twitter / X', icon: '𝕏', href: '#' },
    { label: 'Instagram', icon: '📸', href: '#' },
    { label: 'Facebook', icon: 'f', href: '#' },
    { label: 'LinkedIn', icon: 'in', href: '#' },
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Help Banner */}
      <div className="bg-gradient-to-r from-primary-700 to-primary-900 py-6 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="text-white font-semibold text-lg">Need help? We're here for you.</p>
            <p className="text-primary-200 text-sm">Raise a concern and our team responds within 24 hours.</p>
          </div>
          <div className="flex gap-3">
            <Link to="/help-center"
              className="bg-white text-primary-700 font-semibold px-5 py-2.5 rounded-xl hover:bg-primary-50 transition-colors text-sm">
              🆘 Help Center
            </Link>
            <Link to="/report-problem"
              className="bg-primary-600 border border-primary-400 text-white font-semibold px-5 py-2.5 rounded-xl hover:bg-primary-500 transition-colors text-sm">
              🚨 Report a Problem
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img src={logo} alt="MyBazaarX" className="h-10 w-auto mb-4" />
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              India's smartest AI-powered marketplace. Buy, sell, and discover the best deals near you with verified sellers, real-time chat, and trust-backed commerce.
            </p>
            <div className="flex gap-2 mb-6">
              {socials.map(s => (
                <a key={s.label} href={s.href} aria-label={s.label}
                  className="w-9 h-9 bg-gray-800 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors text-sm font-bold">
                  {s.icon}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-2">
              <a href="#" className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 rounded-xl px-4 py-2.5 transition-colors">
                <span className="text-xl">🍎</span>
                <div><p className="text-xs text-gray-400">Download on</p><p className="text-sm font-semibold text-white">App Store</p></div>
              </a>
              <a href="#" className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 rounded-xl px-4 py-2.5 transition-colors">
                <span className="text-xl">▶</span>
                <div><p className="text-xs text-gray-400">Get it on</p><p className="text-sm font-semibold text-white">Google Play</p></div>
              </a>
            </div>
          </div>

          {/* Buy & Sell */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 flex items-center gap-1.5">
              <span className="text-primary-400">🛒</span> Buy &amp; Sell
            </h4>
            <ul className="space-y-2.5">
              {buyAndSell.map(item => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-gray-400 hover:text-white transition-colors hover:pl-1 duration-150">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 flex items-center gap-1.5">
              <span className="text-primary-400">📂</span> Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.map(item => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-gray-400 hover:text-white transition-colors hover:pl-1 duration-150">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 flex items-center gap-1.5">
              <span className="text-primary-400">🏢</span> Company
            </h4>
            <ul className="space-y-2.5">
              {company.map(item => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-gray-400 hover:text-white transition-colors hover:pl-1 duration-150">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 flex items-center gap-1.5">
              <span className="text-primary-400">🆘</span> Support
            </h4>
            <ul className="space-y-2.5">
              {support.map(item => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-gray-400 hover:text-white transition-colors hover:pl-1 duration-150">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-6 p-3 bg-gray-800 rounded-xl border border-gray-700">
              <p className="text-xs font-semibold text-green-400 mb-1">✅ Trusted Platform</p>
              <p className="text-xs text-gray-500">500K+ verified users. Safe &amp; secure transactions.</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} MyBazaarX. All rights reserved.
            <span className="mx-2">·</span>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <span className="mx-2">·</span>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Use</Link>
            <span className="mx-2">·</span>
            <Link to="/about" className="hover:text-white transition-colors">About Us</Link>
          </p>
          <div className="flex items-center gap-3 text-sm text-gray-500">
            <span>🇮🇳 Made in India</span>
            <span>·</span>
            <span className="flex items-center gap-1">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse-slow" />
              All systems operational
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
